<template>
  <div class="invoices_box">
    <v-card-text>
      <h5 class="accent--text" style="font-size: 12px; font-weight:700; margin-bottom:10px"> Confirmed Invoices </h5>
      <table class="table">
        <thead class="thead">
        <tr>
          <th scope="col">Buyer Name</th>
          <th scope="col">Code</th>
          <th scope="col">Value(USD)</th>
          <th scope="col">No of Bags</th>
          <th scope="col">Invoice Date</th>
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in paginatedItems" v-bind:key="item.id">
          <td>{{ item.buyerName === null ? '' : item.buyerName }}</td>
          <td>{{ item.buyerCode }}</td>
          <td>{{ item.invoiceAmount }}</td>
          <td>{{ item.totalNumberOfBags }}</td>
          <td>{{ item.dateCreated | prettyDate }}</td>
          <td style="color: red;" class="secondary--text actions">...</td>
        </tr>
        </tbody>
      </table>
    </v-card-text>
    <v-card-actions>
      <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinkss }} pages </span>
      <v-spacer></v-spacer>
      <v-pagination
        v-model="page"
        :length="numberOfLinkss"
        :total-visible="7"
        color="secondary"
                class="accent--text logoutbtn"
      ></v-pagination>
    </v-card-actions>
  </div>
</template>
<script>
import axios from 'axios'
import config from '../../config'

export default {
	name: 'BuyerInvoicesDash',
	data: function () {
		return {
			items: [],
			paginatedItems: [],
			numberOfLinkss: 0,
			numberOfItemsPerPage: window.innerHeight <= 600 ? 6 : window.innerHeight > 600 && window.innerHeight <= 1000 ? 14 : 20,
			currentPage: 0,
			page: 1
		}
	},
	mounted () {
		this.getGeneratedInvoices(this.currentPage)
	},
	watch: {
		items: function () {
			// if (this.items.length > 0) {
			this.paginatedItems = this.items()
			// this.paginationMethod(this.items, 1, this.numberOfItemsPerPage)
			// 	this.numberOfLinkss = Math.ceil(this.items.length / this.numberOfItemsPerPage)
			// 	console.log(this.numberOfLinkss)
			// }
		},
		page: function (val) {
			this.paginatedItems = this.getGeneratedInvoices(val - 1)
			// this.paginationMethod(this.items, val, this.numberOfItemsPerPage)
		}
	},
	computed: {},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		getGeneratedInvoices (val) {
			const url = config.serverURI + '/invoice/approved?page=' + val + '&size' + this.numberOfItemsPerPage
			axios.get(url)
				.then(response => {
					this.items = response.data.content
					this.numberOfLinkss = response.data.page.totalPages
					this.numberOfItemsPerPage = response.data.page.size
					this.currentPage = response.data.page.number

					this.$emit('updateInvoicesCount', this.items.length)
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.loading = false
				})
			return this.items
		}
	}
}
</script>
<style>
.invoices_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
  border-radius: 5px;
}

.invoices_box:after, .invoices_box:before {
  bottom: 100%;
  left: 90%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.invoices_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 20px;
  margin-left: -20px;
}

.invoices_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-bottom-color: #707070;
  border-width: 21px;
  margin-left: -21px;
}
</style>
